module.exports = __webpack_public_path__ + "img/blm2.90ce7401.png";